var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJava(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 50,
    style: {
      fill: "#E3E3E3"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M54.8,77l1.7-1l-1.9,0.5c-2.8,0.8-3.2,1.7-3.2,2.4c0.2,1.8,4.8,3.2,10.1,3.2    c2.8,0,6.9-0.4,11.1-2.2l0.6-0.2l-0.6-0.2c-1.9-0.8-3.4-1.6-3.4-1.6l-0.1-0.1H69c-3.4,0.6-5.5,0.9-7.7,0.9c-1.4,0-2.9-0.1-5-0.3    c-1.9-0.2-2.1-0.6-2.1-0.7C54.2,77.4,54.5,77.1,54.8,77z",
    style: {
      fill: "#3969B2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5,73.1l-0.7-0.3c-1.5-0.5-2.4-1.5-2.5-1.5l-0.1-0.1h-0.1c-4.1,0.8-7.3,1.1-10.5,1.1    c-1.8,0-3.6-0.1-6-0.4c-1.6-0.2-2-0.6-2-0.8c-0.1-0.4,0.5-1,0.7-1.2l1.2-0.9L53,69.5c-2.5,0.8-3.7,1.7-3.5,2.7    c0.3,1.7,4.7,2.8,10.8,2.8c4.5,0,9.3-0.7,13.4-1.9L74.5,73.1z",
    style: {
      fill: "#3969B2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,50.5c-0.8,2.5,0,5.3,2.5,8.1c0.8,0.9,1.2,1.9,1.1,2.9c-0.2,1.9-1.8,3.3-1.8,3.3L63,66.3    l2.1-1.1c0.2-0.1,4.3-2.2,5-5.4c0.3-1.3,0-2.6-0.8-3.8l-0.4-0.6c-1.3-1.9-2.4-3.3-2-5c0.5-2.3,3.6-4.9,10.1-8.7l1.5-0.9l-1.7,0.4    C76.2,41.4,64.9,44.2,63,50.5z",
    style: {
      fill: "#F3492C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9,88.1c13.3,0,22.7-2.5,23.2-4.9c0.1-0.4-0.1-1.1-1.3-1.7l-1.7-0.8l1.4,1.2    c0,0,0.4,0.3,0.3,0.7c-0.1,0.3-0.4,0.9-2.2,1.4c-3.5,1.2-11.5,2-19.4,2c-7.4,0-13.1-0.6-15.6-1.7c-0.3-0.1-0.5-0.3-0.5-0.4    c0.1-0.5,2.2-1.4,3.7-1.7c1-0.2,1.6-0.2,1.9-0.2c0.1,0,0.1,0,0.1,0l0.9,0.1L50,81.4c-0.4-0.3-1-0.4-1.8-0.4c-2.9,0-8.4,2-8.6,3.8    c-0.1,0.9,1,1.6,3.3,1.9C48.6,87.6,54.3,88.1,59.9,88.1L59.9,88.1z",
    style: {
      fill: "#3969B2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4,68.6c6.1,0,11.8-0.6,15.9-1.7h0.1c1.2-0.8,2.8-1.5,2.8-1.5l2-0.9L76,65c0,0-4.7,0.8-9.3,1.2    c-3.2,0.3-6.6,0.4-9.5,0.4c-2.2,0-4.1-0.1-5.3-0.3c-2.2-0.3-2.2-0.7-2.2-0.7c0-0.6,3.2-1.7,6.2-2.5l1.6-0.4l-1.6-0.1    c0,0-0.2,0-0.4,0c-1.4,0-5.1,0.2-9.4,2.3c-0.4,0.2-1.4,0.7-1.3,1.4C45,68.1,51.7,68.6,57.4,68.6z",
    style: {
      fill: "#3969B2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,63.4l-0.4,0.7l0.7-0.3c0,0,0.4-0.2,1.3-0.3c0.2,0,0.4-0.1,0.7-0.1c1.4,0,3.1,0.9,3.5,2.6    c0.3,1.2,0.2,4.4-6.8,8h-0.1v0.1c0,0.1-0.1,0.2-0.2,0.2L74.9,75l1-0.3c7.9-2.1,10.4-5.8,10-8.6c-0.3-2.4-2.5-4.1-5.3-4.1    c-0.8,0-1.6,0.1-2.4,0.4C77.4,62.8,77,63.4,77,63.4z",
    style: {
      fill: "#3969B2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7,63l0.9,0.8l-0.5-1.1c-0.5-1.2-1.4-2.4-2.2-3.5c-2.7-3.9-5.5-7.8,2.1-13.8    c5-3.9,7.6-7.8,7.8-11.5c0.2-3.3-1.6-5.1-1.7-5.2L68.5,28l0.2,0.9c1.7,6.7-2.9,10.3-7.4,13.8c-2.2,1.8-4.5,3.6-6,5.7    C52.3,53,57.1,57.9,62.7,63z",
    style: {
      fill: "#F3492C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4,84.8c0,0-1,1.9-9,3.4c-4.6,0.9-10,1.3-15.6,1.3c-4.6,0-9.1-0.3-12.5-0.9l-0.9-0.2l0.8,0.6    c0.2,0.1,1.8,1.2,8.9,1.7c2,0.1,4.2,0.2,6.3,0.2l0,0c10.7,0,22.3-1.6,22.6-6.1l0.1-1.4L85.4,84.8z",
    style: {
      fill: "#3969B2"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJava);
export default __webpack_public_path__ + "static/media/java.e6fa646267dcd3198b7027ff4433bdcc.svg";
export { ForwardRef as ReactComponent };